import { VerifyComponent } from './verify/verify.component';

export const CONTAINERS = [VerifyComponent];

export { VerifyComponent } from './verify/verify.component';
